"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialAidService = void 0;
var axios_1 = __importDefault(require("axios"));
var FinancialAidService = (function () {
    function FinancialAidService(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        this.token = token;
        this.profileId = profileId;
    }
    FinancialAidService.prototype.getAwardSummariesList = function (studentProfileId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, params, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/fin-aid-plan/award-summaries/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            }
                        };
                        params = {
                            filter: { studentProfileId: studentProfileId },
                            range: { page: 1, pageSize: 20 },
                            linkedEntities: true
                        };
                        return [4, axios_1.default.post(url, params, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FinancialAidService.prototype.getDisbursementsList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, params, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/disbursements/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": this.profileId
                            }
                        };
                        params = {
                            range: { page: 1, pageSize: 20 },
                            sort: { orderBy: "name", orderDir: "ASC" }
                        };
                        return [4, axios_1.default.post(url, {}, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return FinancialAidService;
}());
exports.FinancialAidService = FinancialAidService;
//# sourceMappingURL=data:application/json;base64,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